import { motion } from "framer-motion";
import React, { memo } from "react";
import "./data-entry.css";

interface InputFieldProps {
	label?: string;
	disabled?: boolean;
	value: any;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	error?: boolean;
	type?: string;
	placeholder?: string;
}

function InputField({
	label,
	disabled = false,
	value,
	onChange,
	error,
	type = "text",
	placeholder = "Digite aqui.",
}: InputFieldProps) {
	return (
		<div className="input-field-container">
			{label && <div className="select-field-label">{label}</div>}
			<motion.div
				className={`select-field-wrapper ${error ? "error" : ""}`}
				initial={{
					borderColor: "#f2f2f2",
				}}
				animate={{
					borderColor: error ? "rgba(255, 0, 0, 1)" : "#f2f2f2",
				}}
				transition={{ duration: 0.2, ease: "easeIn" }}
			>
				<input
					type={type}
					onChange={onChange}
					value={value}
					disabled={disabled}
					placeholder={placeholder}
					className="select-field-input"
				/>
			</motion.div>
			{error && <div className="error-input-text">Campo obrigatório.</div>}
		</div>
	);
}

export default memo(InputField);
